import React from "react";
import "./Modal.css";

function Modal(props) {
  const handleClose = () => {
    props.onCloseHandler();
  };
  return (
    <div className="modal_overlay">
      <div className="modal_container">
        <div className="modal_container_header">
          <h3 className="addfamily_modal_content_title">{props.title}</h3>
          <span
            style={{ cursor: "pointer", color: "black" }}
            onClick={() => handleClose()}
          >
            <i class="fa fa-times fa-lg" aria-hidden="true"></i>
          </span>
        </div>

        <hr />
        <br />

        <div className="modal_container_content">{props.children}</div>
      </div>
    </div>
  );
}

export default Modal;
